import React from "react";
import classes from "./MenuSeparator.module.scss";
import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";

type Section = "Solution" | "Capability";

interface Props {
  section: Section;
}

const MenuSeparator: React.FC<Props> = ({ section }) => {
  const cx = classNames.bind(classes);
  const { t } = useTranslation();
  const text = {
    Solution: t("add_solutions_separator"),
    Capability: t("add_capabilities_separator"),
  };

  return (
    <div className={classes.menuSeparator}>
      <span className={cx("addUnpurchased", section)}>{text[section]}</span>
    </div>
  );
};

export default MenuSeparator;
